export default __webpack_public_path__ + "static/media/logoFPU.e20c9d94.png";